import { useEffect, useRef, useState } from 'react';
import { TimerProps } from './types';
import { defaultTimerValue, timer } from './utils';

export const useTimer = ({ timerKey, timerDefaultValue = 60, restartDependancy, runTimerAfterClick }: TimerProps) => {
    const [timerValue, setTimerValue] = useState<number>(timerDefaultValue);
    const timerId = useRef<NodeJS.Timeout>();

    const isTimerEnd = timerValue <= 0 || runTimerAfterClick;

    const updateTimerFromLocal = () => {
        setTimerValue(defaultTimerValue(timerKey, timerDefaultValue));
    };

    useEffect(() => {
        const isInit = localStorage.getItem(timerKey);
        if (!isInit) {
            localStorage.setItem(timerKey, Date.now().toString());
        }
    }, []);

    useEffect(() => {
        if (restartDependancy) {
            localStorage.setItem(timerKey, Date.now().toString());
            updateTimerFromLocal();
            return () => localStorage.removeItem(timerKey);
        }
    }, [restartDependancy]);

    useEffect(() => {
        const updateTimer = () => {
            const newTime = defaultTimerValue(timerKey, timerDefaultValue);
            if (newTime <= 0) {
                clearInterval(timerId.current);
                setTimerValue(0);
            } else {
                setTimerValue(newTime);
            }
        };
        updateTimer();
        timerId.current = setInterval(updateTimer, 333);
        return () => {
            clearInterval(timerId.current);
        };
    }, [restartDependancy]);

    return {
        timerValue,
        isTimerEnd,
        formatValue: timer(timerValue),
    };
};
